import React from "react";

import { Hero, Service, Menu, AboutUs } from "../sections";

const Home = () => {
  return (
    <>
      <Hero />
      <Service />
      <Menu />
      <AboutUs />
    </>
  );
};

export default Home;
